import React from "react";
import Chart from "react-google-charts";
import Typography from "@material-ui/core/Typography";
import { withStyles } from "@material-ui/core/styles";
//import Link from "@material-ui/core/Link";

const styles = {
  para: {
    fontSize: 16
  },
  imgdiv: {
    textAlign: "center",
    margin: "10px"
  },
  img: {
    borderRadius: "8px",
    border: "1px solid gray",
    width: "80%"
  }
};

const Gantt = props => {
  //const { classes } = props;
  return (
    <div style={{ width: "100%" }}>
      <Typography variant="h5">Gantt Chart</Typography>

      <Chart
        width={"300"}
        height={"300px"}
        chartType="Gantt"
        loader={<div>Loading Chart</div>}
        data={[
          [
            { type: "string", label: "Task ID" },
            { type: "string", label: "Task Name" },
            { type: "date", label: "Start Date" },
            { type: "date", label: "End Date" },
            { type: "number", label: "Duration" },
            { type: "number", label: "Percent Complete" },
            { type: "string", label: "Dependencies" }
          ],
          [
            "Research",
            "Find sources",
            new Date(2015, 0, 1),
            new Date(2015, 0, 5),
            null,
            100,
            null
          ],
          [
            "Write",
            "Write paper",
            null,
            new Date(2015, 0, 9),
            3 * 24 * 60 * 60 * 1000,
            25,
            "Research,Outline"
          ],
          [
            "Cite",
            "Create bibliography",
            null,
            new Date(2015, 0, 7),
            1 * 24 * 60 * 60 * 1000,
            20,
            "Research"
          ],
          [
            "Complete",
            "Hand in paper",
            null,
            new Date(2015, 0, 10),
            1 * 24 * 60 * 60 * 1000,
            0,
            "Cite,Write"
          ],
          [
            "Outline",
            "Outline paper",
            null,
            new Date(2015, 0, 6),
            1 * 24 * 60 * 60 * 1000,
            100,
            "Research"
          ]
        ]}
        rootProps={{ "data-testid": "1" }}
      />
    </div>
  );
};

export default withStyles(styles)(Gantt);
